import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {LoaderService} from '@app/core/services/loader/loader.service';
import {StoreService} from '@app/feature/store-admin/services/store.service';
import {NotificationService} from '@app/core/services/notification/notification.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ErrorhandlerService} from '@app/shared/services/errorhandler/errorhandler.service';
import {ProductService} from '@app/shared/services/product/product.service';
import {HttpClient} from '@angular/common/http';
import {CreateStoreComponent} from '@app/feature/store-admin/components/create-store/create-store.component';


@Component({
  selector: 'app-popup-select-store',
  templateUrl: './popup-select-store.component.html',
  styleUrls: ['./popup-select-store.component.css']

})
export class PopupSelectStoreComponent implements OnInit {

  ApplicationUserId !: any;
  storeList !: any[];
  storeForm: FormGroup;
  selectedStore: any = '';
  key = '';
  companyId: number;
  constructor(public dialogRef: MatDialogRef<PopupSelectStoreComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
              private loaderService: LoaderService, private storeService: StoreService, private notificationService: NotificationService,
              private fb: FormBuilder, private router: Router, private errorhandlerService: ErrorhandlerService,
              private activatedRoute: ActivatedRoute,
              public dialog: MatDialog) {
    this.storeForm = this.fb.group({
      selectedStore: ['', Validators.required],
    });
  }

  ngOnInit() {

    this.ApplicationUserId = localStorage.getItem('userId');
    this.companyId = parseInt(localStorage.getItem('companyId'));

    this.fn_getStoreList();
    this.activatedRoute.queryParams.subscribe(params => {
      this.key = params['apikey'];
    });
  }

  /** Function to get store list */
  fn_getStoreList() {

    this.loaderService.show();
    this.storeService.getStoreList('', 0,
      10, true, this.ApplicationUserId, false).subscribe((res: any) => {
      if (res.StatusCode === 200) {

        this.storeList = res.Data.ResponseData;
        this.loaderService.hide();
        this.loaderService.lazyLoaderHide();
      } else if (res.StatusCode === 204 || res.StatusCode === 404) {
        this.loaderService.hide();
        this.loaderService.lazyLoaderHide();
      }
    }, (err: any) => {
      this.loaderService.hide();
      this.loaderService.lazyLoaderHide();
      // this.notificationService.error('An error occured', 'Error');
      this.errorhandlerService.handleError(err);
    });
  }

  fn_publish(form: FormGroup) {

    this.loaderService.show();
    this.storeService.updateStoreKey({apikey: this.key, StoreId: this.selectedStore}).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.notificationService.success('Updated Sucessfully', 'Store');
        // this.router.navigate(['store/list']);
        this.loaderService.hide();
      } else if (res.StatusCode === 500) {
        this.notificationService.error('An error occured', 'Try again');
        this.loaderService.hide();
      } else {
        this.loaderService.hide();
      }
    }, err => {
      this.notificationService.error('An error occured', 'Error');
      this.loaderService.hide();
    });

    this.dialogRef.close();
  }

  fn_SelectPublishProducts(event: any, storeId: string, form: FormGroup) {
    this.selectedStore = storeId;
  }
  addStore() {
    this.selectedStore = 0;
    const dialogRef1 = this.dialog.open(CreateStoreComponent, {
    });

    dialogRef1.afterClosed().subscribe(() => {
      this.fn_getStoreList();
    });
  }
}
